import React from 'react';
import { useBonusTermsAndConditionsLoader } from '@/hooks/useBonusTermsAndConditionsLoader';
import { Helmet } from 'react-helmet-async';
import PageHeader from '@/components/Layout/PageHeader';
import LegalCmsContent from '@/components/shared/LegalCmsContent';
import { useIntl } from 'react-intl';
import { Button } from '@/components/buttons/Button';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';

const BonusTermsAndConditions = () => {
  const { tcData, tcLoading } = useBonusTermsAndConditionsLoader();
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();

  return (
    <>
      {tcData && (
        <Helmet>
          <title>LuckyDays - {tcData.title}</title>
        </Helmet>
      )}
      <PageHeader>
        <h1>{tcData?.title}</h1>
        <Button
          className="text-center"
          type="button"
          btnType="primary"
          onClickHandler={() => navigate('/')}
          text={intl.formatMessage({ id: 'bonusCard.claimBonusButton' })}
        />
      </PageHeader>
      <LegalCmsContent data={tcData} loading={tcLoading} showTitle={false} />
    </>
  );
};

export default BonusTermsAndConditions;
